/* ------------------------------------------------------------------------ */
/*		File: cmpSearch.tsx                                                 */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React, { useState } from "react";
import { ICard } from "./cmpSearch.d";
import { getImage } from "../GenericComponents/functions";
import "./cmpSearch.css";

/* ------------------------------------------------------------------------ */

const Search: React.FC<ICard> = ({card, onClick}) => {
    const [inputValue, setInputValue] = useState('');

    const handleChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setInputValue(event.target.value);
    };

    const handlerEvent = () => {
        let values = inputValue?.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()?"']/g, ' ');
        values = values.replace(/[^a-zA-Z0-9\s@]/g, '');
        values = values.replace(/\s+/g, ' ').trim();
        if (onClick) { onClick(values!.toLowerCase()) }
    }

    return (
        <div className="card_search">
            <div className="card_search_content">
                <input 
                    type="text"
                    autoComplete=""
                    value={inputValue} 
                    placeholder={card.label}
                    onChange={handleChange} 
                    onBlur={handlerEvent}
                />
                <img 
                    src={getImage(card.src)} 
                    alt={card.src}
                    onClick={handlerEvent}
                />
            </div>
        </div>
    );

};
export default Search;

